import { Buildings, X } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

type Props = {
	count: number;
	onClear: () => void;
	onAssign: () => void;
};

export function DmSourceSelectionBar({ count, onClear, onAssign }: Props) {
	const { t } = useTranslation();
	return (
		<div
			inert={count === 0 ? true : undefined}
			className={`flex h-full w-full items-center justify-between bg-muted px-4 transition-opacity duration-150 ${
				count === 0
					? "pointer-events-none opacity-0"
					: "pointer-events-auto opacity-100"
			}`}
		>
			<div className="flex items-center gap-2">
				<Button
					variant="ghost"
					size="icon"
					className="-ml-2 size-7 shrink-0"
					onClick={onClear}
					aria-label={t("mqttSources.clearSelection")}
				>
					<X className="size-3.5" aria-hidden="true" />
				</Button>
				<p className="text-sm text-muted-foreground whitespace-nowrap">
					<span className="font-semibold text-foreground tabular-nums">
						{count}
					</span>{" "}
					{count === 1
						? t("mqttSources.selectedOne")
						: t("mqttSources.selectedOther")}
				</p>
			</div>
			<div className="flex items-center gap-2">
				<Button variant="outline" className="gap-2" onClick={onAssign}>
					<Buildings className="size-4 shrink-0" aria-hidden="true" />
					<span className="hidden sm:inline">
						{t("mqttSources.bulkAssignAction")}
					</span>
				</Button>
			</div>
		</div>
	);
}
